'use client';

import { c as _c } from "react/compiler-runtime";
import { AlertTriangle } from 'lucide-react';
import type { PrazoEsclarecimento } from '../../types/encerramento.types';
import { formatarData } from '../../utils/formatarEncerramento';
import { classesDoTom } from '../../utils/tonsEncerramento';
interface BlocoPrazoDocumentoProps {
  readonly prazo: PrazoEsclarecimento | null;
  readonly variante: 'destaque' | 'tabela';
}
export function BlocoPrazoDocumento(t0) {
  const $ = _c(36);
  const {
    prazo,
    variante
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = classesDoTom("atencao");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const tomAtencao = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = classesDoTom("erro");
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const tomErro = t2;
  if (!prazo) {
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <div className={`rounded-[8px] border p-3 ${tomErro.caixa}`}><p className={`text-xs font-medium ${tomErro.texto}`}>Prazo não registrado</p><p className="text-xs text-neutral-700">Nenhum prazo de esclarecimento foi iniciado para esta intimação. Sem prazo registrado, este documento não sustenta a contagem.</p></div>;
      $[2] = t3;
    } else {
      t3 = $[2];
    }
    return t3;
  }
  if (variante === "destaque") {
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <p className={`text-xs ${tomAtencao.texto}`}>Prazo para pedido de esclarecimento</p>;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    const t4 = prazo.diasUteis;
    let t5;
    if ($[4] !== prazo.vencimentoEm) {
      t5 = formatarData(prazo.vencimentoEm);
      $[4] = prazo.vencimentoEm;
      $[5] = t5;
    } else {
      t5 = $[5];
    }
    let t6;
    if ($[6] !== prazo.diasUteis || $[7] !== t5) {
      t6 = <p className="text-[15px] font-medium text-neutral-900">{t4} dias úteis — até {t5}</p>;
      $[6] = prazo.diasUteis;
      $[7] = t5;
      $[8] = t6;
    } else {
      t6 = $[8];
    }
    let t7;
    if ($[9] !== prazo.calendarioFeriadosAusente) {
      t7 = prazo.calendarioFeriadosAusente ? <AvisoCalendario /> : null;
      $[9] = prazo.calendarioFeriadosAusente;
      $[10] = t7;
    } else {
      t7 = $[10];
    }
    let t8;
    if ($[11] !== t6 || $[12] !== t7) {
      t8 = <div className={`rounded-[8px] p-3.5 ${tomAtencao.caixa}`}>{t3}{t6}{t7}</div>;
      $[11] = t6;
      $[12] = t7;
      $[13] = t8;
    } else {
      t8 = $[13];
    }
    return t8;
  }
  let t3;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <dt className="text-xs text-neutral-600">Prazo iniciado</dt>;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  let t4;
  if ($[15] !== prazo.iniciadoEm) {
    t4 = formatarData(prazo.iniciadoEm);
    $[15] = prazo.iniciadoEm;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] !== t4) {
    t5 = <div>{t3}<dd className="text-sm text-neutral-900">{t4}</dd></div>;
    $[17] = t4;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== prazo.diasUteis) {
    t6 = <dt className="text-xs text-neutral-600">Vencimento — {prazo.diasUteis} dias úteis</dt>;
    $[19] = prazo.diasUteis;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== prazo.vencimentoEm) {
    t7 = formatarData(prazo.vencimentoEm);
    $[21] = prazo.vencimentoEm;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== t7) {
    t8 = <dd className="text-sm text-neutral-900">{t7}</dd>;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== t6 || $[26] !== t8) {
    t9 = <div className="text-right">{t6}{t8}</div>;
    $[25] = t6;
    $[26] = t8;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] !== t5 || $[29] !== t9) {
    t10 = <dl className="flex justify-between gap-4">{t5}{t9}</dl>;
    $[28] = t5;
    $[29] = t9;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  let t11;
  if ($[31] !== prazo.calendarioFeriadosAusente) {
    t11 = prazo.calendarioFeriadosAusente ? <AvisoCalendario /> : null;
    $[31] = prazo.calendarioFeriadosAusente;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  let t12;
  if ($[33] !== t10 || $[34] !== t11) {
    t12 = <div className="rounded-[8px] bg-neutral-50 p-3.5">{t10}{t11}</div>;
    $[33] = t10;
    $[34] = t11;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  return t12;
}
function AvisoCalendario() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = classesDoTom("erro");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const tomErro = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <p className={`mt-2 flex items-start gap-1.5 text-xs ${tomErro.texto}`}><AlertTriangle aria-hidden="true" className="mt-0.5 h-3.5 w-3.5 shrink-0" />Calendário de feriados do ano não cadastrado — a data de vencimento pode estar incorreta.</p>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}